module.exports = __webpack_public_path__ + "static/img/Megaphone-Off.6ce77397.svg";